import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { categoryList } from '@/mocks/manga';

export default function CategoryNav() {
  const [activeSlug, setActiveSlug] = useState('all');
  const navigate = useNavigate();

  const handleCategoryClick = (slug: string) => {
    setActiveSlug(slug);
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  return (
    <section className="py-8 md:py-10 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            分类浏览
          </h2>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {categoryList.map((cat) => {
            const isActive = activeSlug === cat.slug;
            return (
              <button
                key={cat.slug}
                onClick={() => handleCategoryClick(cat.slug)}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                }`}
              >
                <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
                {cat.name}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}